import { deleteSourceUrl } from '@core/api'
import { httpClient } from '@core/http-client'

/**
 * Delete an audio source
 * @param id - Audio source id
 */
export const deleteAudioSource = (id: string) => {
    return httpClient.delete(deleteSourceUrl(id))
}
